import { defineComponent as V, useSlots as R, ref as b, computed as k, openBlock as e, createElementBlock as n, normalizeClass as N, createElementVNode as c, createBlock as d, resolveDynamicComponent as S, toRaw as T, toDisplayString as l, createCommentVNode as a, renderSlot as I, unref as r, withCtx as v, createTextVNode as y, createSlots as z } from "vue";
import { RevButton as A } from "@ds/components/Button";
import { RevButtonIcon as E } from "@ds/components/ButtonIcon";
import { RevToggle as $ } from "@ds/components/Toggle";
import U from "../../icons/generated/IconCross.vue2.js";
import { tw as s } from "../../utils/tailwind.js";
const j = { class: "mr-12 shrink-0" }, q = { class: "flex grow flex-col gap-12 pr-12 pt-2" }, F = { class: "flex flex-col gap-8" }, G = { class: "body-2-bold" }, H = {
  key: 0,
  class: "text-static-default-low caption"
}, J = {
  key: 0,
  class: "space-y-12 pb-4"
}, K = {
  key: 0,
  class: "text-static-default-mid body-2"
}, Y = /* @__PURE__ */ V({
  name: "RevInfoBlock",
  __name: "InfoBlock",
  props: {
    icon: {},
    title: {},
    caption: { default: "" },
    variant: {},
    content: { default: "" },
    cta: { default: "" },
    dismissable: { type: Boolean, default: !1 },
    dismissLabel: { default: "" },
    toggleLabel: { default: "" },
    toggleDescription: { default: "" }
  },
  emits: ["dismiss", "toggle", "click"],
  setup(t, { emit: h }) {
    const i = t, u = h, p = R(), m = b(!1), f = b(!1), x = k(() => i.content || i.cta || i.toggleLabel || p.default), C = k(() => ({
      default: s`bg-static-default-mid`,
      info: s`bg-static-info-mid`,
      success: s`bg-static-success-mid`,
      danger: s`bg-static-danger-mid`,
      warning: s`bg-static-warning-mid`
    })[i.variant]);
    function w(o) {
      u("click", o);
    }
    function B() {
      f.value = !0, u("dismiss");
    }
    function D(o) {
      u("toggle", o);
    }
    return (o, g) => f.value ? a("", !0) : (e(), n("div", {
      key: 0,
      class: N(["text-static-default-hi rounded-lg flex w-full py-16 pl-16 pr-8", C.value]),
      "data-test": "content"
    }, [
      c("div", j, [
        (e(), d(S(T(t.icon)), {
          class: "w-24",
          "data-test": "icon"
        }))
      ]),
      c("div", q, [
        c("div", F, [
          c("p", G, l(t.title), 1),
          t.caption ? (e(), n("p", H, l(t.caption), 1)) : a("", !0)
        ]),
        x.value ? (e(), n("div", J, [
          t.content ? (e(), n("p", K, l(t.content), 1)) : a("", !0),
          I(o.$slots, "default"),
          t.cta ? (e(), d(r(A), {
            key: 1,
            size: "small",
            variant: "primary",
            onClick: w
          }, {
            default: v(() => [
              y(l(t.cta), 1)
            ]),
            _: 1
          })) : a("", !0),
          t.toggleLabel ? (e(), d(r($), {
            key: 2,
            modelValue: m.value,
            "onUpdate:modelValue": [
              g[0] || (g[0] = (L) => m.value = L),
              D
            ],
            "data-test": "toggle",
            label: t.toggleLabel
          }, z({ _: 2 }, [
            t.toggleDescription ? {
              name: "default",
              fn: v(() => [
                y(l(t.toggleDescription), 1)
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["modelValue", "label"])) : a("", !0)
        ])) : a("", !0)
      ]),
      t.dismissable ? (e(), d(r(E), {
        key: 0,
        "aria-label": t.dismissLabel,
        class: "shrink-0",
        "data-test": "dismiss-button",
        icon: r(U),
        variant: "ghost",
        onClick: B
      }, null, 8, ["aria-label", "icon"])) : a("", !0)
    ], 2));
  }
});
export {
  Y as default
};
